import React from 'react'
import { useSelector } from 'react-redux'
import { getIsLoading, getIsOver, getIsStarted, getLoadingError, getMe } from './gameSlice'
import useGame from './useGame'
import LoadingView from './components/loading-view'
import ErrorView from './components/error-view'
import PlayGameContainer from './PlayGameContainer'
import WatchGameContainer from './WatchGameContainer'
import GameLobbyContainer from './GameLobbyContainer'
import GameOverContainer from './GameOverContainer'

export interface GameProps {
    id: string
}

export default function Game({ id }: GameProps) {
    useGame(id) // load and refresh game

    const isLoading = useSelector(getIsLoading)
    const loadingError = useSelector(getLoadingError)
    const isOver = useSelector(getIsOver)
    const isStarted = useSelector(getIsStarted)
    const me = useSelector(getMe)

    if (loadingError) {
        return <ErrorView message={loadingError} />
    }
    
    if (isLoading) {
        return <LoadingView />
    }

    if (isOver) {
        return <GameOverContainer />
    }

    if (isStarted && me) {
        return <PlayGameContainer />
    }

    if (isStarted) {
        return <WatchGameContainer />
    }

    return <GameLobbyContainer />
}

